export const SUPPORTED_CAROUSEL_HEIGHTS: any = {
  LARGE: 180,
  STANDARD: 154,
  XLARGE: 200,
  XXLARGE: 248,
}

export const MINIMUM_SWIPE_DISTANCE = 50

export const VIEW_THRESHOLD = 1 // card is 100% in view
